import { useRecoilValue } from "recoil" ;
import { translationsState } from "state/ecoState";


/**
 * Load all translations from backend in Recoil store.
 * Should be used at application bootsrap to ensure translations
 * are made available thanks to @see {@link useTranslation} hook.
 * 
 */
const useLoadTranslations = () => {
    return useRecoilValue(translationsState)
}


export default useLoadTranslations ;